<div class="right-menu-container mr-md-2 mr-sm-3">
  <div class="right-menu-wrapper">
    <div class="dropdown d-none d-lg-block">
      <div class="tooltip-container">
        <button
          *ngIf="!(pathService.getCurrentPath().includes('posta') || pathService.getCurrentPath().includes('not') || pathService.getCurrentPath().includes('kimlik'))"
          class="btn btn-primary btn-sm ti-plus"
          #newButton
          [hidden]="hidden"
          (click)="onNewButtonClick()"
          [disabled]="!showNewButton || pathService.getCurrentPath().includes('yardim-merkezi')"
          data-bs-toggle="dropdown"
          id="newButtonId"
        >
          {{ 'NEW' | translate }}
        </button>
        <span class="tooltip-text" *ngIf="!showNewButton || pathService.getCurrentPath().includes('yardim-merkezi')">{{ 'DISABLED_BUTTON_TEXT' | translate }}</span>
        <div class="dropdown-menu button-popup-container dropdown-menu-end hide-dropdown" id="dropdown">
          <div class="link-item" *ngIf="!securedFolder" id="navNewFolder" (click)="openCreateFolderModal('#createFolderModal')">
            <div class="img-container">
              <img src="assets/images/suite/storage/file-icons/icon_folder.svg" alt="" />
            </div>
            <div class="text-container my-2">
              <span class="text-style" id="navNewFolder">{{ 'NEW_FOLDER' | translate }}</span>
            </div>
          </div>
          <div class="link-item" *ngIf="isSafelockEnabled && securedFolder" id="navNewEncryptedFolder" (click)="openCreateFolderModal('#createEncryptedFolderModal')">
            <div class="img-container">
              <img src="assets/images/suite/storage/file-icons/icon_foldersecure.svg" alt="" />
            </div>
            <div class="text-container my-2">
              <span class="text-style">{{ 'NEW_ECRYPTED_FOLDER' | translate }}</span>
            </div>
          </div>
          <div class="link-item" *ngIf="isSafelockEnabled && securedFolder" (click)="onFolderUploadClick()" id="uploadEncryptedFolder">
            <div class="img-container">
              <img src="assets/images/suite/storage/secure-upload-folder.svg" alt="" />
            </div>
            <div class="text-container my-2">
              <span class="text-style">{{ 'UPLOAD_ENCRYPTED_FOLDER' | translate }}</span>
            </div>
          </div>
          <div class="link-item" *ngIf="isSafelockEnabled && securedFolder" (click)="fileInput.click()" id="uploadEncryptedFile">
            <div class="img-container">
              <img src="assets/images/suite/storage/secure-upload.svg" alt="" />
            </div>
            <div class="text-container my-2">
              <span class="text-style">{{ 'UPLOAD_ENCRYPTED_FILE' | translate }}</span>
            </div>
          </div>
          <div class="link-item" *ngIf="!securedFolder" (click)="onFolderUploadClick()" id="uploadFolder">
            <div class="img-container">
              <img src="assets/images/suite/storage/uploadfolder.svg" alt="" />
            </div>
            <div class="text-container my-2">
              <span class="text-style">{{ 'UPLOAD_FOLDER' | translate }}</span>
            </div>
          </div>
          <div class="link-item" *ngIf="!securedFolder" (click)="fileInput.click()" id="navUploadFolder">
            <div class="img-container">
              <img src="assets/images/suite/storage/upload-file.svg" alt="" />
            </div>
            <div class="text-container my-2">
              <span class="text-style">{{ 'UPLOAD_FILE' | translate }}</span>
            </div>
          </div>
          <hr />
          <div
            class="link-item"
            [class.disabled-item]="isSafelockEnabled && securedFolder"
            (click)="OnDocxClick()"
            data-bs-toggle="modal"
            data-bs-target="#createEmptyDocumentModal"
            id="navNevDoc"
          >
            <div class="img-container">
              <img src="assets/images/suite/storage/file-icons/icon_word.svg" alt="" />
            </div>
            <div class="text-container my-2">
              <span class="text-style">{{ 'NEW_DOCX_DOCUMENT' | translate }}</span>
            </div>
          </div>
          <div
            class="link-item"
            [class.disabled-item]="isSafelockEnabled && securedFolder"
            (click)="OnPptClick()"
            data-bs-toggle="modal"
            data-bs-target="#createEmptyDocumentModal"
            id="navNewPpt"
          >
            <div class="img-container">
              <img src="assets/images/suite/storage/file-icons/icon_powpt.svg" alt="" />
            </div>
            <div class="text-container my-2">
              <span class="text-style">{{ 'NEW_PPT_DOCUMENT' | translate }}</span>
            </div>
          </div>
          <div
            class="link-item"
            [class.disabled-item]="isSafelockEnabled && securedFolder"
            (click)="OnXlsxClick()"
            data-bs-toggle="modal"
            data-bs-target="#createEmptyDocumentModal"
            id="navNewXls"
          >
            <div class="img-container">
              <img src="assets/images/suite/storage/file-icons/icon_excel.svg" alt="" />
            </div>
            <div class="text-container my-2">
              <span class="text-style">{{ 'NEW_XLS_DOCUMENT' | translate }}</span>
            </div>
          </div>
          <hr class="mb-3" />
          <div class="link-item mb-2" [class.disabled-item]="isSafelockEnabled && securedFolder" data-bs-toggle="modal" data-bs-target="#documentTemplate">
            <div class="img-container">
              <i class="ti ti-suitcase"></i>
            </div>
            <div class="text-container my-1" data-bs-toggle="modal" data-bs-target="#documentTemplate" id="navTemplateId" (click)="OnTemplateDocumentClick()">
              <span class="text-style">{{ 'SELECT_FROM_CORPORATE_TEMPLATE' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dropdown">
      <div *ngIf="authStore.userProfileLoaded$ | async" class="profile-picture-container c-pointer" data-bs-toggle="dropdown">
        <app-profile-image [firstName]="userData.firstName" [lastName]="userData.lastName" [image]="userData.imageId"> </app-profile-image>
      </div>
      <div class="dropdown-menu profile-popup-container" id="profile-dropdown">
        <div class="profile-name-avatar-container">
          <div class="profile-name-avatar-wrapper">
            <div class="profile-picture-container">
              <app-profile-image [firstName]="userData.firstName" [lastName]="userData.lastName" [image]="userData.imageId"> </app-profile-image>
            </div>
            <div *ngIf="authStore.userProfileLoaded$ | async" class="name-email-container ms-3">
              <div class="name-wrapper c-default">{{ userData.firstName | case : 'title' }} {{ userData.lastName | case : 'upper' }} </div>
              <div class="email-wrapper c-default">
                <span class="email-style">{{ userData.email }}</span>
              </div>
            </div>
          </div>
        </div>
        <hr class="mb-2 mt-2" />
        <div class="profile-setting-security-container">
          <div class="profile-setting-container c-pointer" (click)="this.commonService.isInPubliclyShared.next(false)" routerLink="{{ profileSettingLink }}" id="profileSettings">
            <span class="menu-item-icon ti-user ti-lg" ng-reflect-ng-class="ti-user ti-lg"></span>
            <span class="setting-style">{{ 'EDIT_PROFILE' | translate }}</span>
          </div>
          <div
            class="profile-setting-container c-pointer"
            (click)="this.commonService.isInPubliclyShared.next(false)"
            routerLink="{{ securitySettingsLink }}"
            id="securitySettings"
          >
            <span class="menu-item-icon ti-lock-on ti-lg" ng-reflect-ng-class="ti-lock-on ti-lg"></span>
            <span class="setting-style">{{ 'SECURITY_SETTINGS' | translate }}</span>
          </div>
          <div class="profile-setting-container c-pointer" (click)="this.commonService.isInPubliclyShared.next(false)" routerLink="{{ secureSettingLink }}" id="secureSettings">
            <img class="c-pointer" src="assets/images/suite/secure-key.svg" alt="" />
            <span class="setting-style">{{ 'SECURE_SETTINGS' | translate }}</span>
          </div>
          <hr class="mt-2" />
          <div class="profile-setting-container c-pointer" (click)="onExitClick()" id="logoutButton">
            <span class="menu-item-icon ti-logout ti-lg" ng-reflect-ng-class="ti-user ti-lg"></span>
            <span class="setting-style">{{ 'LOGOUT' | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<input #fileInput type="file" class="d-none" (change)="onFilesSelected(fileInput.files)" multiple />
<input #folderInput type="file" class="d-none" (change)="onFoldersSelected(folderInput.files)" webkitDirectory />
